import React, { useMemo, useState } from 'react';

import {
  HStack, Stack, Center, Image,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import ZoomImage from 'containers/Modals/ZoomImage';
import { ChecklistTypes } from 'enums/types';

export default function VehicleImage({ inputs, index, execution }) {
  const [image, setImage] = useState<string>();
  const { register, getValues } = useFormContext();
  const type = getValues('type');

  const links = useMemo(() => {
    const data: GenericObject = {};
    execution?.fields?.forEach(({ label, imageUrl }) => {
      switch (label) {
        case 'Visão Lateral Esquerda':
          data.leftSide = imageUrl;
          break;
        case 'Visão Frontal':
          data.front = imageUrl;
          break;
        case 'Visão Lateral Direita':
          data.rightSide = imageUrl;
          break;
        case 'Visão Traseira':
          data.back = imageUrl;
          break;
        default:
          break;
      }
    });
    return data;
  }, [execution]);

  const images = useMemo(() => ({
    rightSide: type.label === ChecklistTypes.Vehicles ? '/images/car-right-side.png' : '/images/moto-right-side.png',
    leftSide: type.label === ChecklistTypes.Vehicles ? '/images/car-left-side.png' : '/images/moto-left-side.png',
    front: type.label === ChecklistTypes.Vehicles ? '/images/car-front.png' : '/images/moto-front.png',
    back: type.label === ChecklistTypes.Vehicles ? '/images/car-back.png' : '/images/moto-back.png',
  }), [type, links]);
  return (
    <Stack>
      <ZoomImage
        isOpen={!!image}
        onClose={() => setImage(undefined)}
        data={image}
      />
      <HStack>
        <Center
          cursor="pointer"
          onClick={() => {
            setImage(links.rightSide);
          }}
          borderRadius={8}
          bg="white.default"
          flex={2}
          height={250}
          alignItems="center">
          <Image
            {...register(`fields.${index}.inputs.0.label`, { value: inputs[0]?.label })}
            height={200}
            objectFit="contain"
            src={links.rightSide ?? images.rightSide}
          />
        </Center>
        <Center
          cursor="pointer"
          onClick={() => setImage(links.front)}
          borderRadius={8}
          bg="white.default"
          flex={1}
          height={250}>
          <Image
            {...register(`fields.${index}.inputs.1.label`, { value: inputs[1]?.label })}
            height={200}
            objectFit="contain"
            src={links.front ?? images.front}
          />
        </Center>
      </HStack>
      <HStack>
        <Center
          cursor="pointer"
          onClick={() => setImage(links.leftSide)}
          borderRadius={8}
          bg="white.default"
          flex={2}
          height={250}
          alignItems="center">
          <Image
            {...register(`fields.${index}.inputs.2.label`, { value: inputs[2]?.label })}
            height={200}
            objectFit="contain"
            src={links.leftSide ?? images.leftSide}
          />
        </Center>
        <Center
          cursor="pointer"
          onClick={() => setImage(links.back)}
          borderRadius={8}
          bg="white.default"
          flex={1}
          height={250}>
          <Image
            {...register(`fields.${index}.inputs.3.label`, { value: inputs[3]?.label })}
            height={200}
            objectFit="contain"
            src={links.back ?? images.back}
          />
        </Center>
      </HStack>
    </Stack>
  );
}
